import { Dispatch, FC, SetStateAction, memo } from 'react'
import { Flex, Icon, Tooltip } from '@chakra-ui/react'

import { EyeHidden, Pencil } from 'components/icons'

type Props = {
  context?: string
  setContext: Dispatch<SetStateAction<string>>
}

const SlugActionsIcons: FC<Props> = ({ context = 'create', setContext }) => {
  return (
    <Flex align="center" gap={1}>
      <Tooltip label="Slug é a parte de uma URL que pode ser legível tanto para humanos quanto para mecanismos de busca.">
        <Icon className="accessible" _hover={{ color: 'primary' }} />
      </Tooltip>
      {context === 'create' ? (
        <Pencil className="accessible" _hover={{ color: 'primary' }} onClick={() => setContext('edit')} />
      ) : (
        <EyeHidden className="accessible" _hover={{ color: 'primary' }} onClick={() => setContext('create')} />
      )}
    </Flex>
  )
}

export default memo(SlugActionsIcons)
